var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMdDomainPrevention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 47,
    viewBox: "0 0 38 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 40,
    x: 2.5,
    y: 5,
    fill: "#CFCFCF",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 39,
    x: 2.5,
    y: 5,
    fill: "#E6E6E6",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.5 10h23v30h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M7.5 40h23V25.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.5 5a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4h-25a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h25m0-2h-25a6 6 0 0 0-6 6v32a6 6 0 0 0 6 6h25a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30.5 10v30h-23V10h23m0-2h-23a2 2 0 0 0-2 2v30a2 2 0 0 0 2 2h23a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC6127",
    d: "M23.67 15.99h-2.66v-2.66h-4.02v2.66h-2.66v4.02h2.66v2.66h4.02v-2.66h2.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21 13.33V16h2.66v4H21v2.66h-4V20h-2.67v-4H17v-2.67h4m0-1h-4a1 1 0 0 0-1 1V15h-1.67a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1H16v1.66a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V21h1.66a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H22v-1.67a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D84F10",
    d: "M14.33 18.15v1.86h2.66v2.66h4.02v-2.66h2.66v-1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#909090",
    d: "M21.81 5A3.06 3.06 0 0 0 22 4a3 3 0 1 0-6 0c.004.341.065.679.18 1H12.5v4h13V5h-3.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    d: "M12.5 7h13v2h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19 1a3 3 0 0 1 3 3 3.06 3.06 0 0 1-.18 1h3.68v4h-13V5h3.69A3.06 3.06 0 0 1 16 4a3 3 0 0 1 3-3m0-1a4 4 0 0 0-4 4h-2.5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H23a4 4 0 0 0-4-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 3.99,
    r: 1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.87 30.4a1 1 0 0 1-.71-.29L10 29a1 1 0 1 1 1.41-1.42l.45.45 1.76-1.76A1 1 0 0 1 15 27.64l-2.47 2.47a1 1 0 0 1-.66.29zM26.7 27.67H18a.5.5 0 1 1 0-1h8.7a.5.5 0 1 1 0 1zM22.7 29.67H18a.5.5 0 1 1 0-1h4.7a.5.5 0 1 1 0 1zM11.87 36.4a1 1 0 0 1-.71-.29L10 35a1 1 0 1 1 1.41-1.42l.45.45 1.76-1.76A1 1 0 0 1 15 33.64l-2.47 2.47a1 1 0 0 1-.66.29zM26.7 33.67H18a.5.5 0 1 1 0-1h8.7a.5.5 0 1 1 0 1zM22.7 35.67H18a.5.5 0 1 1 0-1h4.7a.5.5 0 1 1 0 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdDomainPrevention);
export default __webpack_public_path__ + "static/media/ic_md_domain_prevention.b1672638ad998192114ae59072c33ba3.svg";
export { ForwardRef as ReactComponent };